import React, { useState } from 'react';
import {
  Modal,
  Form,
  Rate,
  Input,
  Button,
  message,
  notification,
  ConfigProvider,
} from 'antd';
import { feedbackService } from '../services/feedbackService';

const FEEDBACK_RATE_THEME = {
  components: {
    Rate: {
      starBg: '#bfbfbf',
      starColor: '#faad14',
      starSize: 26,
    },
  },
};

const { TextArea } = Input;

const FeedbackModal = ({ 
  visible, 
  onCancel, 
  onSuccess,
  question = '',
  response = '',
  feedbackType = 'positive',
  userId = null,
  sessionId = null
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState(0);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const feedbackData = {
        question: question,
        response: response,
        feedback_type: feedbackType,
        user_id: userId,
        session_id: sessionId,
        rating: rating > 0 ? rating : null,
        additional_comments: values.additional_comments || null,
      };

      await feedbackService.submitFeedback(feedbackData);
      
      // Show thank you notification in the right corner
      notification.success({
        message: 'Thank You!',
        description: 'Your feedback has been submitted successfully. We appreciate your input!',
        placement: 'topRight',
        duration: 4,
        style: {
          marginTop: 20,
        },
      });
      
      form.resetFields();
      setRating(0);
      onSuccess?.();
      onCancel();
    } catch (error) {
      message.error(error.message || 'Failed to submit feedback. Please try again.');
      console.error('Feedback submission error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setRating(0);
    onCancel();
  };

  return (
    <Modal
      title="Provide Feedback"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={500}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ marginTop: 20 }}
      >
        <Form.Item label="Rating (1-5 stars)">
          <ConfigProvider theme={FEEDBACK_RATE_THEME}>
            <Rate
              value={rating}
              onChange={setRating}
              allowClear
              className="feedback-modal-rate"
            />
          </ConfigProvider>
        </Form.Item>

        <Form.Item
          label="Additional Comments"
          name="additional_comments"
        >
          <TextArea
            rows={4}
            placeholder="Please share any additional comments or suggestions..."
            maxLength={1000}
            showCount
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit Feedback
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FeedbackModal;

